// Expand menu or whatever other switching you want to do
function switcher ( toggle_button, wrapper_element, class_toggle, initialise = false ) {
    var toggler = document.getElementById( toggle_button );
    var wrapper = document.getElementById( wrapper_element );
    if( null !== toggler && null !== wrapper ){
        if( initialise ) {
            wrapper.classList.toggle( class_toggle );
        }
        toggler.addEventListener( 'click', function (e) {
            e.preventDefault();
            wrapper.classList.toggle( class_toggle );
        });
    }
}
export default switcher;